import { useEffect, useState } from 'react';
import { PinKeypad, PIN_DIGIT_COUNT } from './PinKeypad';

// Set/Change-PIN flow. Two-step: enter, confirm. On confirm-mismatch the
// flow restarts. On confirm-match, calls onSet(pin).
export function PinSetPrompt({
  onSet,
  onCancel,
}: {
  onSet: (pin: string) => void;
  onCancel: () => void;
}) {
  const [step, setStep] = useState<'enter' | 'confirm'>('enter');
  const [first, setFirst] = useState('');
  const [pin, setPin] = useState('');
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (pin.length !== PIN_DIGIT_COUNT) return;
    if (step === 'enter') {
      setFirst(pin);
      setPin('');
      setStep('confirm');
      return;
    }
    if (pin === first) {
      onSet(pin);
      return;
    }
    // Mismatch: shake, then restart at step 1.
    setShake(true);
    const t = setTimeout(() => {
      setShake(false);
      setStep('enter');
      setFirst('');
      setPin('');
    }, 500);
    return () => clearTimeout(t);
  }, [pin, step, first, onSet]);

  const title = step === 'enter' ? 'Aseta PIN' : 'Vahvista PIN';

  return (
    <div className="pin-modal" role="dialog" aria-label={title}>
      <h2 className="pin-title">🔐 {title}</h2>
      <PinKeypad value={pin} onChange={setPin} shake={shake} />
      <button type="button" className="pin-cancel" onClick={onCancel}>
        Peruuta
      </button>
    </div>
  );
}
